<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Cadastro de <strong>Estudante</strong></h4>

    <form @submit.prevent="handlerSubmit" ref="formStudent">
      <div class="row">

        <input type="file" name="image">

        <div class="form-group col-md-4">
          <label for="name">Nome</label>
          <input
            type="text"
            class="form-control"
            name="name"
          />
        </div>
        <div class="form-group col-md-2">
          <label for="gender">Gênero</label>
          <select name="gender" class="form-control">
            <option disabled selected value="">-- Selecione --</option>
            <option value="F">F</option>
            <option value="M">M</option>
          </select>
       
        </div>
        <div class="form-group col-md-6">
          <label for="email">E-mail</label>
          <input
            type="email"
            class="form-control"
            name="email"
          />
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-4">
          <label for="name">Endereço</label>
          <input
            type="text"
            class="form-control"
            name="street"
          />
        </div>

        <div class="form-group col-md-2">
          <label for="name">Número</label>
          <input
            type="text"
            class="form-control"
            name="number"
          />
        </div>

        <div class="form-group col-md-1">
          <label for="name">CEP</label>
          <input 
              type="text"
              maxlength="8"
              class="form-control" 
              name="cep"
              @blur="zipCodeQuery"
          />
        </div>
        <div class="form-group col-md-1">
          <label for="name">Bairro</label>
          <input
            type="text"
            class="form-control"
            name="neighborhood"
          />
        </div>
        <div class="form-group col-md-2">
          <label for="name">Cidade</label>
          <input
            type="text"
            class="form-control"
            name="city"
          />
        </div>
        <div class="form-group col-md-2">
          <label for="name">Estado</label>
          <input
            type="text"
            class="form-control"
            name="uf"
          />
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="phone">Telefone</label>
        
          <TheMask 
              type="text"
              class="form-control" 
              :mask="['(##)#####-#####']"
              :masked="true"
              name="phone"
            />
        </div>
        <div class="form-group col-md-6">
          <label for="cpf">CPF</label>
          <TheMask 
              type="text"
              class="form-control" 
              :mask="['###.###.###-##']"
              name="cpf"
            />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="rg">RG</label>
          <input 
            type="text" 
            class="form-control" 
            id="rg" 
            name="rg" 
          />
        </div>
        <div class="form-group col-md-6">
          <label for="expedient_body">Orgão expedidor</label>
          <input
            type="text"
            class="form-control"
            name="expedient_body"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="nationality">Nacionalidade</label>
          <input
            type="text"
            class="form-control"
            name="nationality"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="naturalness">Naturalidade</label>
          <input
            type="text"
            class="form-control"
            name="naturalness"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="birth_date">Data de nascimento</label>
          <input
            type="date"
            class="form-control"
            name="birth_date"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="name_mother">Nome da mãe</label>
          <input
            type="text"
            class="form-control"
            name="name_mother"
          />
        </div>
      </div>

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2">
          SALVAR
        </button>
        <button type="reset" class="btn btn-secondary btn-sm">LIMPAR</button>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import axios from "axios";

import { errorsToString } from "@/helpers";

export default {
  name: "StudentRegister",
  data() {
    return {
      item:[]
    };
  }, 
  methods: {
    async zipCodeQuery() { //@TODO mover para uma unica funcao.

      const cepLimpo = this.$refs.formStudent.cep.value.replace(/\D/g, '')

      if (cepLimpo.length !== 8) 
        return

      try {

        const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`)
        
        if (!response.data.erro) {
          this.$refs.formStudent.street.value = response.data.logradouro
          this.$refs.formStudent.neighborhood.value = response.data.bairro
          this.$refs.formStudent.uf.value = response.data.uf
          this.$refs.formStudent.city.value = response.data.localidade
        } else {
          this.$refs.formStudent.street.value = ''
          this.$refs.formStudent.neighborhood.value = ''
          this.$refs.formStudent.uf.value = ''
          this.$refs.formStudent.city.value = ''
          Toast.fire("Erro", 'CEP não encontrado', "error")
        }
      } catch (error) {
        console.error('Erro ao consultar CEP:', error)
        Toast.fire("Erro", 'Erro ao buscar informações do CEP', "error")
      }
      },
      async handlerSubmit() {

      const formData = new FormData(this.$refs.formStudent);
      formData.set('cpf', formData.get('cpf').replace(/[.\-]/g, ''));
      formData.set('cep', formData.get('cep').replace(/[.\-]/g, ''));

      try {
        const { data } = await api.post(`/students`, formData);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "students" });
      } catch (error) {
        Toast.fire(errorsToString(error.response.data.errors || {'error':[error.response.data.message]}), "", "error");
      }
    },
  },
};
</script>

<style scoped>
</style>